'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckAllLoaded = exports.showAllTemplates = exports.btnFinishClick = exports.requestedMethodsAllowed = exports.SetRequestedMethodsAllowed = exports.btnBackClick = exports.btnNextClick = exports.btnQuickSaveClick = exports.ValidateAllTabs = exports.fillFieldsFromAanvraagData = exports.Init = exports.AanvraagObj = exports.EditMode = exports.$dialogSaveResult = void 0;
var MandatoryFields;
var DoNotValidate = false;
var $dialogGetTemplateName;
var $dialogToSlurryOrNotToSlurry;
exports.EditMode = false;
var $hfDateTime;
var _UploadData;
var methodesSlurry = [];
var $tbTemplateName;
var $tbFilterTemplate;
var opslaanGelukt;
var $LblTemplateNameInUse;
var $tableTemplates;
var $dialogLoading;
var $progressbarLoading;
var progressbarLoadingValue = 0;
var MandatoryFieldsLoaded = false;
var CustomerDefaults;
var Algemeen = require("./Algemeen");
var Contact = require("./AanvraagAlgemeneInfo/Contact");
var Country = require("./AanvraagAlgemeneInfo/Country");
var SampleNature = require("./AanvraagAlgemeneInfo/SampleNature");
var AanvraagAlgemeneInfo = require("./AanvraagAlgemeneInfo");
var AanvraagStaal = require("./AanvraagStaal");
var AanvraagMethodes = require("./AanvraagMethodes");
var AanvraagReports = require("./AanvraagReports");
var Methodes = require("./AanvraagMethodes/Methodes");
var ApplicationDate = require("./AanvraagStaal/ApplicationDate");
function Init() {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Algemeen.CallWebServiceGetGenericSync('GetCustomerDefaults')];
                case 1:
                    result = _a.sent();
                    CustomerDefaults = result.d;
                    $("#tabs").tabs({
                        beforeActivate: function (event, ui) { TabsBeforeActivate(event, ui); },
                        activate: function (event, ui) { TabsActivate(event, ui); },
                        disabled: [1, 2, 3]
                    });
                    //    $("#tabs").tabs({
                    //        beforeActivate: function (event, ui) { TabsBeforeActivate(event, ui); },
                    //        activate: function (event, ui) { TabsActivate(event, ui); },
                    //        disabled: [],
                    //        active : 3
                    //    });
                    $progressbarLoading = $("#progressbarLoading");
                    $progressbarLoading.progressbar({
                        value: 0,
                        max: 15
                    });
                    $dialogLoading = $("#dialogLoading");
                    $dialogLoading.dialog({
                        autoOpen: true,
                        modal: true,
                        dialogClass: 'noTitleDialog',
                        height: 60
                    });
                    $hfDateTime = $('#ctl00_cphBody_HFDateTime');
                    if ($hfDateTime.val() != '') { //Check edit mode
                        exports.EditMode = true;
                        $("#tabs").tabs("option", "disabled", []);
                        Algemeen.CallWebServiceGetGenericData("GetAanvraagData", "{'DateTime' : '" + $hfDateTime.val() + "'}", OnSuccessGetAanvraag);
                    }
                    else {
                        InitAll();
                    }
                    exports.$dialogSaveResult = $("#dialogSaveResult");
                    exports.$dialogSaveResult.dialog({
                        autoOpen: false,
                        modal: true,
                        width: 400,
                        buttons: [
                            {
                                text: Algemeen.Translate('nmOk'),
                                click: function () {
                                    DialogSaveResultOK(this);
                                }
                            }
                        ]
                    });
                    $dialogToSlurryOrNotToSlurry = $('#dialogToSlurryOrNotToSlurry');
                    $dialogToSlurryOrNotToSlurry.dialog({
                        autoOpen: false,
                        modal: true,
                        width: 430,
                        buttons: [
                            {
                                text: Algemeen.Translate('nmJa'),
                                click: function () {
                                    _UploadData.MethodsProductsSlurried = methodesSlurry;
                                    SaveAanvraagCheckTemplate();
                                    $dialogToSlurryOrNotToSlurry.dialog("close");
                                }
                            },
                            {
                                text: Algemeen.Translate('nmNee'),
                                click: function () {
                                    _UploadData.MethodsProductsSlurried = [];
                                    SaveAanvraagCheckTemplate();
                                    $dialogToSlurryOrNotToSlurry.dialog("close");
                                }
                            },
                            {
                                text: Algemeen.Translate('nmAnnuleer'),
                                click: function () { $dialogToSlurryOrNotToSlurry.dialog("close"); }
                            }
                        ],
                        close: function (event, ui) { return false; }
                    });
                    $dialogGetTemplateName = $("#dialogGetTemplateName");
                    $dialogGetTemplateName.dialog({
                        autoOpen: false,
                        modal: true,
                        width: 500,
                        buttons: [
                            {
                                text: Algemeen.Translate('nmOk'),
                                click: function () { GetTemplateNameOK(); }
                            },
                            {
                                text: Algemeen.Translate('nmAnnuleer'),
                                click: function () { GetTemplateNameCancel(); }
                            }
                        ],
                        close: function (event, ui) { GetTemplateNameCancel(); }
                    });
                    $LblTemplateNameInUse = $('#ctl00_cphBody_LblTemplateNameInUse');
                    $LblTemplateNameInUse.hide();
                    //$('#ctl00_mnuMenu a').click(function (e) { alert('test'); });
                    if (exports.EditMode) {
                        $('.cbSaveAsTemplate').hide();
                        $('.spanSaveAsTemplate').hide();
                    }
                    else {
                        $('#cbSaveAsTemplate1').change(function (e) { $('#cbSaveAsTemplate2').prop('checked', this.checked); }); //('checked', this.prop('checked')); });
                        $('#cbSaveAsTemplate2').change(function (e) { $('#cbSaveAsTemplate1').prop('checked', this.checked); }); //('checked', this.prop('checked')); });
                        $('.spanSaveAsTemplate').click(function () { $('.cbSaveAsTemplate').prop('checked', !$('.cbSaveAsTemplate').is(':checked')); });
                        $('.btnQuickSave').hide();
                    }
                    $tbTemplateName = $('#tbTemplateName');
                    $tbTemplateName.keydown(function (e) { tbTemplateNameOnkeydown(e); });
                    $tableTemplates = $('#tableTemplates')[0];
                    $tbFilterTemplate = $('#tbFilterTemplate');
                    $tbFilterTemplate.keyup(function (e) { tbFilterTemplateOnKeyUp(e); });
                    $tbFilterTemplate.keydown(function (e) { tbFilterTemplateOnKeyDown(e); });
                    return [2 /*return*/];
            }
        });
    });
}
exports.Init = Init;
function InitAll() {
    AanvraagAlgemeneInfo.InitAlgemeneInfo(CustomerDefaults);
    AanvraagStaal.InitStaal();
    AanvraagMethodes.InitMethodes();
    AanvraagReports.InitReports();
    Algemeen.CallWebServiceGetGeneric('MandatoryFields', OnSuccessGetMandatoryFields);
    if (!exports.EditMode) {
        Algemeen.CallWebServiceGetGeneric('GetAanvraagTemplates', AanvraagAlgemeneInfo.OnSuccessGetAanvraagTemplates);
    }
}
function OnSuccessGetAanvraag(data, status) {
    Algemeen.CheckSessionTimeout(data);
    exports.AanvraagObj = data.d;
    InitAll();
    fillFieldsFromAanvraagData(exports.AanvraagObj, false);
}
function fillFieldsFromAanvraagData(AanvraagData, template) {
    if (exports.EditMode) {
        AanvraagAlgemeneInfo.tbSequenceNumber.val(AanvraagData.SequenceNumber);
        AanvraagAlgemeneInfo.tbCustomerReference.val(AanvraagData.CustomerReference);
        AanvraagAlgemeneInfo.tbExtraIdentification.val(AanvraagData.ExtraIdentification);
    }
    Contact.cbContact.$tb.val(AanvraagData.Contact);
    AanvraagAlgemeneInfo.tbBrand.val(AanvraagData.Brand);
    AanvraagAlgemeneInfo.tbBrix.val(AanvraagData.Brix);
    AanvraagAlgemeneInfo.tbRemark.val(AanvraagData.Remark);
    AanvraagStaal.tbLocation.val(AanvraagData.Location);
    AanvraagStaal.tbPackaging.val(AanvraagData.Packaging);
    AanvraagStaal.tbSupplyRemark.val(AanvraagData.SupplyRemark);
    AanvraagStaal.tbDestinationInfo.val(AanvraagData.DestinationInfo);
    AanvraagAlgemeneInfo.tbPDFNaam.val(AanvraagData.PDFNaam);
    AanvraagAlgemeneInfo.tbLotNr.val(AanvraagData.LotNr);
    AanvraagAlgemeneInfo.tbAantalFotos.val(AanvraagData.AantalFotos);
    AanvraagAlgemeneInfo.chkBio.prop('checked', AanvraagData.Bio);
    if (!template) {
        ApplicationDate.$tbApplicationDate.val(AanvraagData.ApplicationDate);
        AanvraagStaal.tbSealNumber1.val(AanvraagData.SealNumber1);
        AanvraagStaal.tbSealNumber2.val(AanvraagData.SealNumber2);
        AanvraagAlgemeneInfo.tbReference.val(AanvraagData.Reference);
        AanvraagAlgemeneInfo.tbPDFNaam.val(AanvraagData.PDFNaam);
        AanvraagAlgemeneInfo.tbLotNr.val(AanvraagData.LotNr);
        AanvraagAlgemeneInfo.tbAantalFotos.val(AanvraagData.AantalFotos);
    }
}
exports.fillFieldsFromAanvraagData = fillFieldsFromAanvraagData;
function UploadData() {
    this.SampleNature = '';
    this.Contact = '';
    this.Producer = '';
    this.CountryOfOrigine = '';
    this.CountryOfDestination = '';
    this.SequenceNumber = '';
    this.Reference = '';
    this.InvoiceCustomer = '';
    this.CustomerReference = '';
    this.ExtraIdentification = '';
    this.Brand = '';
    this.Processing = '';
    this.Brix = '';
    this.ControlType = '';
    this.ControlNumber = '';
    this.Priority = '';
    this.Remark = '';
    this.ApplicationDate = '';
    this.By = '';
    this.Location = '';
    this.SealNumber1 = '';
    this.SealNumber2 = '';
    this.TransportMethod = '';
    this.Packaging = '';
    this.SupplyRemark = '';
    this.DestinationInfo = '';
    this.MethodsProducts = new Array();
    this.CommunicationMethods = new Array();
    this.TemplateName = '';
    this.PDFNaam = '';
    this.LotNr = '';
    this.AantalFotos = '';
}
function ValidateAllTabs() {
    var allTabsValid = true;
    if (!ValidateTab(TabsNumberToName(0))) {
        allTabsValid = false;
    }
    if (!ValidateTab(TabsNumberToName(1))) {
        allTabsValid = false;
    }
    if (!ValidateTab(TabsNumberToName(2))) {
        allTabsValid = false;
    }
    if (!ValidateTab(TabsNumberToName(3))) {
        allTabsValid = false;
    }
    return allTabsValid;
}
exports.ValidateAllTabs = ValidateAllTabs;
function btnQuickSaveClick() {
    $('.btnNavigate').prop('disabled', true);
    ValidateMethodRestrictions().then(function (result) {
        if (result) {
            if (ValidateAllTabs()) {
                SaveAanvraag();
                Contact.SaveContacts();
            }
        }
        else {
            Methodes.fillSummary();
        }
        $('.btnNavigate').prop('disabled', false);
    });
}
exports.btnQuickSaveClick = btnQuickSaveClick;
function btnNextClick() {
    var active = $("#tabs").tabs("option", "active");
    if (ValidateTab(TabsNumberToName(active))) {
        DoNotValidate = true;
        $("#tabs").tabs("enable", active + 1);
        $("#tabs").tabs("option", "active", active + 1);
        DoNotValidate = false;
    }
}
exports.btnNextClick = btnNextClick;
function btnBackClick() {
    var active = $("#tabs").tabs("option", "active");
    ValidateTab(TabsNumberToName(active));
    DoNotValidate = true;
    $("#tabs").tabs("option", "active", active - 1);
    DoNotValidate = false;
}
exports.btnBackClick = btnBackClick;
//GET DATA 
function OnSuccessGetMandatoryFields(data, status) {
    Algemeen.CheckSessionTimeout(data);
    MandatoryFields = data.d;
    //  InitMethods();
    AddMandatoryIndication(MandatoryFields.SampleNature, SampleNature.cbSampleNature.$tb);
    AddMandatoryIndication(MandatoryFields.Contact, Contact.tbContact);
    AddMandatoryIndication(MandatoryFields.ProducerNumber, AanvraagAlgemeneInfo.tbProducer);
    AddMandatoryIndication(MandatoryFields.CountryOrigine, Country.tbCountryOfOrigine);
    AddMandatoryIndication(MandatoryFields.CountryDestination, Country.tbCountryOfDestination);
    AddMandatoryIndication(MandatoryFields.AuctionSequenceNumber, AanvraagAlgemeneInfo.tbSequenceNumber);
    AddMandatoryIndication(MandatoryFields.ReferenceNumber, AanvraagAlgemeneInfo.tbReference);
    AddMandatoryIndication(false, AanvraagAlgemeneInfo.tbInvoiceCustomer);
    AddMandatoryIndication(MandatoryFields.CustomerDescription, AanvraagAlgemeneInfo.tbCustomerReference);
    AddMandatoryIndication(MandatoryFields.AdditionalIdentificationCustomer, AanvraagAlgemeneInfo.tbExtraIdentification);
    AddMandatoryIndication(MandatoryFields.Brand, AanvraagAlgemeneInfo.tbBrand);
    AddMandatoryIndication(MandatoryFields.Processing, AanvraagAlgemeneInfo.tbProcessing);
    AddMandatoryIndication(MandatoryFields.Brix, AanvraagAlgemeneInfo.tbBrix);
    AddMandatoryIndication(false, AanvraagAlgemeneInfo.tbControlType);
    AddMandatoryIndication(MandatoryFields.AuctionSequenceNumber, AanvraagAlgemeneInfo.tbControlNumber);
    AddMandatoryIndication(MandatoryFields.Priority, AanvraagAlgemeneInfo.tbPriority);
    AddMandatoryIndication(MandatoryFields.SupplyRemark, AanvraagAlgemeneInfo.tbRemark);
    AddMandatoryIndication(true, ApplicationDate.$tbApplicationDate);
    AddMandatoryIndication(MandatoryFields.SampleDeliveredBy, AanvraagStaal.tbBy);
    AddMandatoryIndication(MandatoryFields.AdditionalDestinationInfo, AanvraagStaal.tbLocation);
    AddMandatoryIndication(MandatoryFields.Sealnumber1, AanvraagStaal.tbSealNumber1);
    AddMandatoryIndication(MandatoryFields.Sealnumber2, AanvraagStaal.tbSealNumber2);
    AddMandatoryIndication(MandatoryFields.SampleDeliveryMethod, AanvraagStaal.tbTransportMethod);
    AddMandatoryIndication(MandatoryFields.Packaging, AanvraagStaal.tbPackaging);
    AddMandatoryIndication(MandatoryFields.SupplyRemark, AanvraagStaal.tbSupplyRemark);
    AddMandatoryIndication(MandatoryFields.AdditionalDestinationInfo, AanvraagStaal.tbDestinationInfo);
    AddMandatoryIndication(MandatoryFields.Pdf, AanvraagAlgemeneInfo.tbPDFNaam);
    AddMandatoryIndication(MandatoryFields.LotNr, AanvraagAlgemeneInfo.tbLotNr);
    MandatoryFieldsLoaded = true;
    CheckAllLoaded();
}
function AddMandatoryIndication(Mandatory, $control) {
    try {
        if (Mandatory) {
            $control.parent().find('.NoRequiredFieldIndication').removeClass('NoRequiredFieldIndication').addClass('RequiredFieldIndication').html('*');
            $control.addClass('RequiredField');
        }
        else {
            //$control.before('<span class="NoRequiredFieldIndication"></span>');
        }
    }
    catch (e) {
        throw e;
    }
}
function TabsBeforeActivate(event, ui) {
    if (!DoNotValidate) {
        if (!ValidateTab(ui.oldTab.find("a").attr("href"))) {
            event.preventDefault();
        }
    }
}
function TabsActivate(event, ui) {
    switch (ui.newTab.index()) {
        case 0:
            $("#dialogSummary").dialog("close");
            if (!exports.EditMode) {
                $("#dialogTemplates").dialog("open");
            }
            break;
        case 2:
            $("#dialogSummary").dialog("open");
            $("#dialogTemplates").dialog("close");
            break;
        default:
            $("#dialogSummary").dialog("close");
            $("#dialogTemplates").dialog("close");
            break;
    }
}
function ValidateTab(tabName) {
    var allowed = false;
    switch (tabName) {
        case "#tabGeneral":
        case "#tabStaal":
            allowed = Algemeen.Validate($(tabName));
            break;
        case "#tabMethods":
            allowed = AanvraagMethodes.ValidateMethods();
            break;
        case "#tabReports":
            allowed = true;
            break;
        default:
            break;
    }
    var tabNameControl = tabName.replace('#', '');
    var theTabButton = $('#tabs').find("[aria-controls='".concat(tabNameControl, "']"));
    if (!allowed)
        theTabButton.addClass('ui-state-error');
    else
        theTabButton.removeClass('ui-state-error');
    return allowed;
}
function SetRequestedMethodsAllowed(value) {
    exports.requestedMethodsAllowed = value;
}
exports.SetRequestedMethodsAllowed = SetRequestedMethodsAllowed;
exports.requestedMethodsAllowed = true;
function ValidateMethodRestrictions() {
    return __awaiter(this, void 0, void 0, function () {
        var result, requestContainsRestrictedMethods, resultGet, i, resutGetText, eRestrictionText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    exports.requestedMethodsAllowed = true;
                    fillUploadData();
                    return [4 /*yield*/, Algemeen.CallWebServiceGetGenericDataSync('CheckRequestContainsRestrictedMethods', JSON.stringify({ aanvraagData: _UploadData }))];
                case 1:
                    result = _a.sent();
                    requestContainsRestrictedMethods = result.d;
                    if (!requestContainsRestrictedMethods) return [3 /*break*/, 4];
                    return [4 /*yield*/, Algemeen.CallWebServiceGetGenericDataSync('GetRestrictedMethods', JSON.stringify({ aanvraagData: _UploadData }))];
                case 2:
                    resultGet = _a.sent();
                    listOfRestrictedMethods = '';
                    for (i = 0; i < resultGet.d.length; i++) {
                        listOfRestrictedMethods += resultGet.d[i].Method + ' ' + resultGet.d[i].Description + '<br />';
                    }
                    return [4 /*yield*/, Algemeen.CallWebServiceGetGenericDataSync('GetText', "{textCode: 'E-RESTRICTION'}")];
                case 3:
                    resutGetText = _a.sent();
                    eRestrictionText = resutGetText.d.replace('@1@', '<br />' + listOfRestrictedMethods + '<br />');
                    exports.$dialogSaveResult.html(eRestrictionText);
                    exports.$dialogSaveResult.dialog("open");
                    exports.requestedMethodsAllowed = false;
                    _a.label = 4;
                case 4: return [2 /*return*/, exports.requestedMethodsAllowed];
            }
        });
    });
}
var listOfRestrictedMethods = '';
function TabsNumberToName(number) {
    switch (number) {
        case 0:
            return "#tabGeneral";
        case 1:
            return "#tabStaal";
        case 2:
            return "#tabMethods";
        case 3:
            return "#tabReports";
    }
}
//SEND DATA
function OnSuccessSaveAanvraagData(data, status) {
    opslaanGelukt = data.d;
    if (opslaanGelukt) {
        exports.$dialogSaveResult.html(Algemeen.Translate('nmOpslaanGelukt'));
    }
    else {
        var html = "<div style=\"color:red;font-size:larger;font-weight: bolder;\"><i style=\"padding-right:15px;\" class=\"fa-2x fa-exclamation-triangle fas\" aria-hidden=\"true\"></i>".concat(Algemeen.Translate('nmOpslaanMislukt'), "</div>");
        exports.$dialogSaveResult.html(html);
    }
    exports.$dialogSaveResult.dialog("open");
}
function OnSuccessDeleteAanvraagData(data, status) {
    opslaanGelukt = data.d;
    if (opslaanGelukt) {
        Algemeen.CallWebServiceGetGenericData('SaveAanvraagData', JSON.stringify({ AanvraagData: _UploadData }), OnSuccessSaveAanvraagData);
    }
    else {
        var html = "<div style=\"color:red;font-size:larger;font-weight: bolder;\"><i style=\"padding-right:15px;\" class=\"fa-2x fa-exclamation-triangle fas\" aria-hidden=\"true\"></i>".concat(Algemeen.Translate('nmOpslaanMislukt'), "</div>");
        exports.$dialogSaveResult.html(html);
        //$dialogSaveResult.html(Algemeen.Translate('nmOpslaanMislukt'));
        exports.$dialogSaveResult.dialog("open");
    }
}
function DialogSaveResultOK(obj) {
    if (opslaanGelukt) {
        $(obj).dialog("close");
        location.href = "OverzichtAanvragenNew.aspx";
    }
    else {
        $(obj).dialog("close");
    }
}
function btnFinishClick() {
    ValidateMethodRestrictions().then(function (result) {
        if (result) {
            SaveAanvraag();
            Contact.SaveContacts();
        }
        else {
            Methodes.fillSummary();
        }
    });
}
exports.btnFinishClick = btnFinishClick;
function fillUploadData() {
    _UploadData = new UploadData();
    _UploadData.SampleNature = SampleNature.cbSampleNature.selectedValue;
    _UploadData.Contact = Contact.tbContact.val();
    _UploadData.Producer = AanvraagAlgemeneInfo.tbProducer.val();
    _UploadData.CountryOfOrigine = Country.cbCountryOfOrigine.selectedValue;
    _UploadData.CountryOfDestination = Country.cbCountryOfDestination.selectedValue;
    _UploadData.SequenceNumber = AanvraagAlgemeneInfo.tbSequenceNumber.val();
    _UploadData.Reference = AanvraagAlgemeneInfo.tbReference.val();
    _UploadData.InvoiceCustomer = AanvraagAlgemeneInfo.cbInvoiceCustomer.selectedValue;
    _UploadData.CustomerReference = AanvraagAlgemeneInfo.tbCustomerReference.val();
    _UploadData.ExtraIdentification = AanvraagAlgemeneInfo.tbExtraIdentification.val();
    _UploadData.Brand = AanvraagAlgemeneInfo.tbBrand.val();
    _UploadData.Processing = AanvraagAlgemeneInfo.cbProcessing.selectedValue;
    _UploadData.Brix = AanvraagAlgemeneInfo.tbBrix.val();
    _UploadData.ControlType = AanvraagAlgemeneInfo.cbControlType.selectedValue;
    _UploadData.ControlNumber = AanvraagAlgemeneInfo.cbControlNumber.selectedValue;
    _UploadData.Priority = AanvraagAlgemeneInfo.cbPriority.selectedValue;
    _UploadData.Remark = AanvraagAlgemeneInfo.tbRemark.val();
    _UploadData.ApplicationDate = ApplicationDate.$tbApplicationDate.val();
    _UploadData.By = AanvraagStaal.tbBy.val();
    _UploadData.Location = AanvraagStaal.tbLocation.val();
    _UploadData.SealNumber1 = AanvraagStaal.tbSealNumber1.val();
    _UploadData.SealNumber2 = AanvraagStaal.tbSealNumber2.val();
    _UploadData.TransportMethod = AanvraagStaal.cbTransportMethod.selectedValue;
    _UploadData.Packaging = AanvraagStaal.tbPackaging.val();
    _UploadData.SupplyRemark = AanvraagStaal.tbSupplyRemark.val();
    _UploadData.DestinationInfo = AanvraagStaal.tbDestinationInfo.val();
    _UploadData.MethodsProducts = Methodes.GetMethodsProducts();
    _UploadData.MethodsProductsSlurried = [];
    _UploadData.CommunicationMethods = AanvraagReports.GetAddedCommunicationMethods();
    _UploadData.PDFNaam = AanvraagAlgemeneInfo.tbPDFNaam.val();
    _UploadData.LotNr = AanvraagAlgemeneInfo.tbLotNr.val();
    _UploadData.AantalFotos = AanvraagAlgemeneInfo.tbAantalFotos.val();
    _UploadData.Bio = AanvraagAlgemeneInfo.chkBio.is(":checked");
}
function SaveAanvraag() {
    fillUploadData();
    methodesSlurry = _UploadData.MethodsProducts.filter(function (f) { return f.SlurryPossible; });
    if (methodesSlurry.length > 0) {
        var slurryText_1 = "";
        methodesSlurry.forEach(function (val) {
            slurryText_1 = "".concat(slurryText_1, ", ").concat(val.Code);
        });
        slurryText_1 = slurryText_1.substring(2);
        $('#spanMethodesSlurry').html(slurryText_1);
        $dialogToSlurryOrNotToSlurry.dialog("open");
    }
    else {
        $('#spanMethodesSlurry').html('');
        SaveAanvraagCheckTemplate();
    }
}
function SaveAanvraagCheckTemplate() {
    if ($('.cbSaveAsTemplate').is(':checked')) {
        $dialogGetTemplateName.dialog("open");
    }
    else {
        _UploadData.TemplateName = '';
        SendAanvraagToWebservice();
    }
}
function tbFilterTemplateOnKeyDown(e) {
    switch (e.which) {
        case 27:
            $tbFilterTemplate.val('');
            showAllTemplates();
            e.preventDefault();
            break;
    }
}
function tbFilterTemplateOnKeyUp(e) {
    var filterText = $tbFilterTemplate.val().trim();
    if (filterText == '')
        showAllTemplates();
    else {
        $('#tableTemplates > tr').each(function () {
            var tdke = this.cells[0];
            if (tdke.innerText.toLowerCase().indexOf(filterText.toLowerCase()) >= 0)
                $(this).show();
            else
                $(this).hide();
        });
    }
}
function showAllTemplates() {
    $tbFilterTemplate.val('');
    $('#tableTemplates > tr').each(function () {
        $(this).show();
    });
}
exports.showAllTemplates = showAllTemplates;
function tbTemplateNameOnkeydown(e) {
    switch (e.which) {
        case 13: //Enter
            e.preventDefault();
            GetTemplateNameOK();
            break;
    }
}
function GetTemplateNameOK() {
    if (!TemplateNameValid($tbTemplateName.val())) {
        $tbTemplateName.addClass('FieldInError');
    }
    else {
        $dialogGetTemplateName.dialog("close");
        _UploadData.TemplateName = $tbTemplateName.val();
        SendAanvraagToWebservice();
    }
}
function TemplateNameValid(name) {
    if (name == '') {
        return false;
    }
    for (var i = 0; i < AanvraagAlgemeneInfo.Templates.length; i++) {
        if (name == AanvraagAlgemeneInfo.Templates[i].Description) {
            $LblTemplateNameInUse.show();
            return false;
        }
    }
    return true;
}
function GetTemplateNameCancel() {
    $dialogGetTemplateName.dialog("close");
    $tbTemplateName.removeClass('FieldInError');
    $LblTemplateNameInUse.hide();
}
function SendAanvraagToWebservice() {
    if (exports.EditMode) {
        Algemeen.CallWebServiceGetGenericData('DeleteAanvraagData', "{'DateTime' : '" + $hfDateTime.val() + "'}", OnSuccessDeleteAanvraagData);
    }
    else {
        Algemeen.CallWebServiceGetGenericData('SaveAanvraagData', JSON.stringify({ AanvraagData: _UploadData }), OnSuccessSaveAanvraagData);
    }
}
function CheckAllLoaded() {
    progressbarLoadingValue += 1;
    $progressbarLoading.progressbar("option", "value", progressbarLoadingValue);
    if ((SampleNature.SampleNaturesLoaded) &&
        (Contact.ContactsLoaded) &&
        (AanvraagAlgemeneInfo.cbProducer.Loaded) &&
        (Country.CountriesLoaded) &&
        (AanvraagAlgemeneInfo.cbInvoiceCustomer.Loaded) &&
        (AanvraagAlgemeneInfo.cbProcessing.Loaded) &&
        (AanvraagAlgemeneInfo.cbControlType.Loaded) &&
        (AanvraagAlgemeneInfo.cbControlNumber.Loaded) &&
        (AanvraagAlgemeneInfo.cbPriority.Loaded) &&
        (AanvraagStaal.cbBy.Loaded) &&
        (AanvraagStaal.cbTransportMethod.Loaded) &&
        (Methodes.MethodsFavoritesLoaded) &&
        (Methodes.MethodsLoaded) &&
        (AanvraagReports.ReportsLoaded) &&
        (MandatoryFieldsLoaded)) {
        $dialogLoading.dialog('close');
        Methodes.fillSummary();
    }
}
exports.CheckAllLoaded = CheckAllLoaded;
